module.exports = __webpack_public_path__ + "img/airbus-thumb.ae77d9d7.png";